/**
 * colecciones.js — Catálogo de colecciones editoriales de Edutech Pulse Lab
 *
 * Estados:
 *  'publicada'     → Disponible y enlazable
 *  'en-desarrollo' → Visible pero sin acceso completo
 *  'proximamente'  → Atenuada, sin botón activo
 *
 * url: ruta interna. null = sin landing todavía.
 * externalUrl: enlaza a una URL existente fuera del sistema de colecciones.
 */

export const colecciones = [
  {
    slug: 'ado',
    nombre: 'ADO',
    nombreCompleto: 'Arquitectura de Decisión Organizacional',
    tagline: 'Por qué las iniciativas estratégicas pierden impulso, aunque nadie decida cancelarlas.',
    descripcion:
      'Una colección sobre cómo las organizaciones deciden qué iniciativas reciben recursos, cuáles son absorbidas por la operación y cuáles desaparecen antes de demostrar su valor.',
    descripcionLarga: `Muchas iniciativas estratégicas no desaparecen por una decisión formal de cancelación. Pierden recursos, atención y capacidad hasta que dejan de tener condiciones reales para avanzar.

    ADO examina los mecanismos de decisión —explícitos e implícitos— que determinan qué iniciativas reciben protección, cuáles son absorbidas por la operación y cuáles desaparecen antes de demostrar su valor.`,
    paraQuien:
      'Líderes de innovación, directivos y responsables de proyectos que intentan sostener iniciativas estratégicas dentro de organizaciones con una operación establecida.',
    queAborda:
      'Por qué iniciativas con respaldo, presupuesto y prioridad declarada pierden continuidad, por qué los recursos asignados migran hacia la operación y por qué la exploración suele evaluarse con métricas y horizontes diseñados para el negocio actual.',
    estado: 'en-desarrollo',
    articuloCount: 7,
    conceptoCount: 10,
    url: '/colecciones/ado',
    externalUrl: null,
    destacada: true,
    gradientFrom: '#0c203b',
    gradientTo: '#1a365d',
    icon: 'Network',
    articulos: [
      {
        numero: '00',
        titulo: 'La innovación necesita un lugar para sobrevivir',
        excerpt: '',
        slug: 'ado-00-la-innovacion-necesita-un-lugar',
        readTime: '8 min',
        estado: 'publicado',
      },
      {
        numero: '01',
        titulo: 'La innovación no tiene quién la sostenga',
        excerpt: '',
        slug: 'ado-01-la-innovacion-no-tiene-quien-la-sostenga',
        readTime: '9 min',
        estado: 'publicado',
      },
      {
        numero: '02',
        titulo: 'La iniciativa no fue cancelada. Simplemente dejó de existir',
        excerpt: '',
        slug: 'ado-02-la-iniciativa-dejo-de-existir',
        readTime: '8 min',
        estado: 'publicado',
      },
      {
        numero: '03',
        titulo: 'Fue declarada prioridad estratégica, y aun así no sobrevivió',
        excerpt: '',
        slug: 'ado-03-prioridad-estrategica-no-fue-suficiente',
        readTime: '10 min',
        estado: 'publicado',
      },
      {
        numero: '04',
        titulo: 'La iniciativa tenía datos. El sistema pedía otros',
        excerpt: '',
        slug: 'ado-04-el-sistema-la-volvio-inviable',
        readTime: '9 min',
        estado: 'publicado',
      },
      {
        numero: '05',
        titulo: 'Cuando una iniciativa depende de una persona para sobrevivir',
        excerpt: '',
        slug: 'ado-05-cuando-depende-de-una-persona',
        readTime: '11 min',
        estado: 'publicado',
      },
      {
        numero: '06',
        titulo: 'Una iniciativa puede estar en el roadmap y no tener arquitectura para sobrevivir',
        excerpt: '',
        slug: 'ado-06-arquitectura-para-sobrevivir',
        readTime: '12 min',
        estado: 'publicado',
      },
    ],
    conceptos: [
      'Arquitectura de decisión organizacional',
      'Iniciativa exploratoria',
      'Perfil explorador',
      'Disolución silenciosa',
      'Absorción operativa',
      'Momentum institucional',
      'Caducidad prematura',
      'Inercia por omisión',
      'Redistribución silenciosa',
      'Patrocinio informal',
    ],
  },
  {
    slug: 'proyectos-de-ia',
    nombre: 'Gestión de Proyectos de IA',
    nombreCompleto: 'Gestión de Proyectos de IA',
    tagline: 'Decisiones, readiness, gobierno y operación de iniciativas de inteligencia artificial.',
    descripcion:
      'Decisiones y casos para evaluar la viabilidad, los datos, los riesgos y la operacionalización de proyectos de IA, tomando como referencia PMI-CPMAI.',
    descripcionLarga: `Implementar IA no es instalar tecnología. Es tomar decisiones sobre datos, modelos, riesgos y equipos en contextos donde la incertidumbre es estructural.

Esta colección aplica el marco CPMAI del PMI para ofrecer criterios prácticos de evaluación y decisión en cada etapa del ciclo de vida de un proyecto de IA.`,
    paraQuien:
      'Project managers, líderes tecnológicos, analistas de datos y tomadores de decisión que participan en proyectos de IA dentro de organizaciones.',
    queAborda:
      'Cómo saber si un proyecto de IA está listo para escalar, cuándo tomar una decisión Go/No-Go y qué significa realmente operar un modelo en producción.',
    estado: 'en-desarrollo',
    articuloCount: 1,
    totalArticulos: 6,
    conceptoCount: 0,
    url: '/colecciones/proyectos-de-ia',
    externalUrl: null,
    destacada: false,
    gradientFrom: '#1e1b4b',
    gradientTo: '#312e81',
    icon: 'BrainCircuit',
    articulos: [],
    conceptos: [],
  },
  {
    slug: '7am-library',
    nombre: '7AM Executive Library',
    nombreCompleto: '7AM Executive Library',
    tagline: 'Ideas clave de libros para líderes y profesionales en formatos breves.',
    descripcion:
      'Ideas esenciales de 11 libros sobre liderazgo, innovación y toma de decisiones, convertidas en audioartículos breves para comprender, conectar y aplicar sus conceptos.',
    descripcionLarga: '',
    paraQuien: 'Profesionales y líderes que aprenden en movimiento.',
    queAborda: 'Los conceptos más valiosos de libros de referencia, en episodios breves.',
    estado: 'publicada',
    articuloCount: 3,
    totalArticulos: 11,
    unidadContenido: 'audioartículos',
    conceptoCount: 0,
    url: null,
    externalUrl: '/7am-library',
    destacada: false,
    gradientFrom: '#0f4c36',
    gradientTo: '#166534',
    icon: 'Headphones',
    articulos: [],
    conceptos: [],
  },
];

export const getColeccionBySlug = (slug) => colecciones.find((c) => c.slug === slug);

export const coleccionDestacada = colecciones.find((c) => c.destacada) || colecciones[0];
